import React, { useEffect } from 'react';
import { useStudent } from '../context/StudentContext';
import MessagingDisabledPage from '../pages/MessagingDisabledPage';
import { API_URL } from '../config';

const MessagingGuard = ({ children }) => {
    const { messagingEnabled, loading } = useStudent();
    const canAccessMessaging = messagingEnabled === true;

    useEffect(() => {
        if (!loading && !canAccessMessaging) {
            // Log access attempt for audit
            fetch(`${API_URL}/api/debug-log`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    msg: "Unauthorized messaging access attempt",
                    path: window.location.pathname,
                    timestamp: new Date().toISOString()
                })
            }).catch(() => {});
        }
    }, [loading, canAccessMessaging]);

    if (loading) {
        return (
            <div className="student-loading-screen">
                <h2>Cargando...</h2>
            </div>
        );
    }
  
    if (!canAccessMessaging) {
        return <MessagingDisabledPage />;
    }

    return children;
};

export default MessagingGuard;
